<template>
  <div>
    <b-form-group>
      <b-form-select v-model="selected" @change="loadLanguageAsync">
        <option v-for="(lang) in langs" :key="$t(`msg.${lang}`)" :value="lang">{{$t(`msg.${lang}`)}}</option>
      </b-form-select>
    </b-form-group>
  </div>
</template>
<script>
export default {
  data () {
    return {
      langs: ['en', 'ms', 'zh'],
      loadedLanguages: ['en'],
      selected: null
    }
  },
  mounted () {
    if (this.$cookies.isKey('nedas_lang')) {
      this.loadLanguageAsync(this.$cookies.get('nedas_lang'))
      this.selected = this.$cookies.get('nedas_lang')
    } else {
      this.$cookies.set('nedas_lang', 'en')
      this.selected = this.$cookies.get('nedas_lang')
    }
  },
  methods: {
    setI18nLanguage: function (lang) {
      this.$i18n.locale = lang
      this.$cookies.set('nedas_lang', lang)
    },
    loadLanguageAsync: function (lang) {
      if (this.$i18n.locale !== lang) {
        if (!this.loadedLanguages.includes(lang)) {
          return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`).then(msgs => {
            this.$i18n.setLocaleMessage(lang, msgs[lang])
            this.loadedLanguages.push(lang)
            return this.setI18nLanguage(lang)
          })
        }
        return Promise.resolve(this.setI18nLanguage(lang))
      }
      return Promise.resolve(lang)
    }
  }
}
</script>
